import { create } from "zustand";
import { locationManager } from "@telegram-apps/sdk-react";
import { persist } from "zustand/middleware";

type Location = { latitude: number; longitude: number };

type State = {
  location?: Location;
  isLocationAllowed: boolean | undefined;

  requestLocationOnce: (manual: boolean) => Promise<Location | undefined>;
  clearLocation: () => void;
};

export const useLocationStore = create<State>()(
  persist(
    (set, get) => ({
      location: undefined,
      isLocationAllowed: undefined,

      requestLocationOnce: async (manual: boolean = false) => {
        if (!locationManager.isAvailable) return undefined;
        const allowed = get().isLocationAllowed;

        if (!manual && allowed === false) return undefined;

        try {
          const res = await locationManager.requestLocation();
          if (!res) {
            set({ isLocationAllowed: false });
            return undefined;
          }

          const loc = {
            latitude: res.latitude,
            longitude: res.longitude,
          };

          set({ location: loc, isLocationAllowed: true });
          return loc;
        } catch {
          set({ isLocationAllowed: false });
          return undefined;
        }
      },

      clearLocation: () => set({ location: undefined }),
    }),
    {
      name: "tg-location-allowed",
      partialize: (s) => ({ isLocationAllowed: s.isLocationAllowed }),
    }
  )
);
